import React from 'react';

export const Gallery = (props) => {
  return (
    <section
      id="portfolio"
      style={{
        mt: '60px',
        position: 'relative',
        width: '100%',
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `url('https://img.freepik.com/free-photo/successful-businessmen-seal-deal-with-firm-handshake-generated-by-ai_188544-40065.jpg?uid=R139167315&ga=GA1.1.821665019.1742142147&semt=ais_hybrid&w=740') center center/cover no-repeat`,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0,0,0,0.6)',
          zIndex: 1,
        }}
      />
      <div
        style={{
          position: 'relative',
          zIndex: 2,
          color: '#fff',
          textAlign: 'center',
          maxWidth: 700,
          margin: '0 auto',
          padding: '40px 20px',
        }}
      >
        <h2
          style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: 36,
            fontWeight: 700,
            marginBottom: 24,
            color: '#fff',
          }}
        >
          Inspiration
        </h2>
        <blockquote
          style={{
            fontSize: 28,
            fontStyle: 'italic',
            lineHeight: 1.4,
            margin: '0 auto',
            fontFamily: 'Playfair Display, serif',
          }}
        >
          {' '}
          “Clear advice. Timely action. Trusted outcomes.” <br />{' '}
          <span
            style={{
              fontSize: 18,
              fontWeight: 400,
              display: 'block',
              marginTop: 16,
            }}
          >
            {' '}
            — Nduro Kimotho & Company Advocates
          </span>{' '}
        </blockquote>
      </div>
    </section>
  );
};
